import { render } from "./logs-page-difference.vue?vue&type=template&id=7b2a4155&ts=true"
import script from "./logs-page-difference.ts?vue&type=script&lang=ts"
export * from "./logs-page-difference.ts?vue&type=script&lang=ts"

import "./logs-page-difference.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__